import React from 'react'
import './LinkBlocks.css'
import T1 from '../assets/img/T1.jpg'
import T2 from '../assets/img/T2.jpg'
import T3 from '../assets/img/T3.jpg'
import T4 from '../assets/img/T4.jpg'

import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

const LinkBlocks = (props) => {
  return(
    <ReactCSSTransitionGroup
      transitionName="homeTransition"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionEnter={false}
      transitionLeave={false}>
      <div key={T1} className="linkBlock">
        <Link to="/vertical-landscaping" style={{backgroundImage: `url(${T1})`}}>
          <h2> {props.t('linkBlocksT1')} </h2>
        </Link> 
        <Link to="/decorating-interiors" style={{backgroundImage: `url(${T2})`}}>
          <h2> {props.t('linkBlocksT2')} </h2>
        </Link>
        <Link to="/create-tracks" style={{backgroundImage: `url(${T3})`}}>
          <h2> {props.t('linkBlocksT3')} </h2>
        </Link>
        <Link to="/floristics" style={{backgroundImage: `url(${T4})`}}>
          <h2> {props.t('linkBlocksT4')} </h2>
        </Link>
      </div>
    </ReactCSSTransitionGroup>
  )
}

export default translate('translations')(LinkBlocks)


// WEBPACK FOOTER //
// ./src/components/LinkBlocks.jsx